<template>
<div class="logoContainer">
  <img id="logo" src="../assets/logo.gif">
</div>
</template>

<script setup>
</script>

<style scoped>
.logoContainer {
  width: 100% !important;
  display: flex;
  background-color: #01608d;
  padding: 0.8em;
}

#id {
  justify-content: left;
}
</style>